import React from 'react';
import { X, Check } from 'lucide-react';
export function Comparativa() {
  const rows = [{
    bad: 'Videos sin orden ni sistema',
    good: 'Progresión clara de 0 a fluido'
  }, {
    bad: 'Señas que no armás en frases',
    good: 'Gramática visual desde cero'
  }, {
    bad: 'Material que no es LSA argentino',
    good: '100% LSA argentino 2026'
  }, {
    bad: 'Te bloqueás frente a personas sordas',
    good: '80 frases listas para usar'
  }, {
    bad: 'Aprendés, olvidás, repetís el ciclo',
    good: 'Rutina diaria de 10 minutos'
  }];
  return <section className="bg-white text-lsa-dark py-16 px-5" data-id="element-52">
      <div className="max-w-xl mx-auto" data-id="element-53">
        <h2 className="text-[24px] font-bold text-center mb-8" data-id="element-54">
          Sin LSA Fácil vs. Con LSA Fácil
        </h2>

        <div className="border border-gray-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-55">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-56">
            <div className="p-4 flex items-center justify-center gap-2 font-bold text-red-600 text-sm sm:text-base" data-id="element-57">
              <X size={18} strokeWidth={3} data-id="element-58" /> Sin LSA Fácil
            </div>
            <div className="p-4 flex items-center justify-center gap-2 font-bold text-lsa-celeste text-sm sm:text-base border-l border-gray-200 bg-lsa-light" data-id="element-59">
              <Check size={18} strokeWidth={3} data-id="element-60" /> Con LSA Fácil
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-61">
            {rows.map((row, index) => <div key={index} className="grid grid-cols-2 text-[13px] sm:text-[14px]" data-id="element-62">
                <div className="p-4 text-gray-600 pr-6" data-id="element-63">{row.bad}</div>
                <div className="p-4 font-medium text-lsa-dark border-l border-gray-100 bg-lsa-light/30 pl-6" data-id="element-64">
                  {row.good}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}